import { render, staticRenderFns } from "./ListResponsavelAssociadoView.vue?vue&type=template&id=1174eb51&"
import script from "./ListResponsavelAssociadoView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelAssociadoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports